import React from 'react';
import Routes from '~/routes';

function Bootstrap() {
  return <Routes />;
}

export default Bootstrap;
